import { render, staticRenderFns } from "./privacy-rule.vue?vue&type=template&id=1fe22296&lang=pug&"
import script from "./privacy-rule.vue?vue&type=script&lang=js&"
export * from "./privacy-rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports